import Actions from '../../../constants/Actions';

export async function userSearchChanged(context, search) {
  context.dispatch(Actions.USER_MANAGEMENT_SEARCH_CHANGED, search);
}

export async function userRoleToggled(context, targetKey) {
  context.dispatch(Actions.USER_MANAGEMENT_ROLE_TOGGLED, targetKey);
}

export async function roleEditSaved(context, newRoles) {
  console.log('saving user role changes', newRoles);
  context.dispatch(Actions.USER_MANAGEMENT_ROLE_CHANGE_SAVED, newRoles);
}

export async function saveUserPII(context, state) {
  const {id} = state;
  const result = await context.service.update('userManagement', {}, {
    id: id,
    emailAddress: state.emailAddress,
    firstName: state.firstName,
    lastName: state.lastName,
    title: state.title,
    active: state.active,
    roles: state.roles,
    selectedBranchHierarchy: state.selectedBranchHierarchy,
    regions: state.regions
  });

  context.dispatch(Actions.USER_MANAGEMENT_PII_CHANGED, result.data);
  const router = context.getRouter();
  router.push('/user-management/view/' + id);
}

export async function listManagedUsers(context, managedUsers) {
  console.log('listManagedUsers ', listManagedUsers);

  context.dispatch(Actions.USER_MANAGEMENT_LIST_MANAGED_USERS, managedUsers);
}

export async function createNewUser(context, newUserInfo) {
  const result = await context.service.create('userManagement', {}, newUserInfo);
  // update the store with the new user
  context.dispatch(Actions.USER_MANAGEMENT_CREATE_NEW_USER, result.data);
  const router = context.getRouter();
  router.push('/user-management/view/' + result.data.id);
}

export async function sendPasswordResetEmail(context, {emailAddress} = {}) {
  if (emailAddress) {
    context.dispatch(Actions.USER_MANAGEMENT_PASSWORD_RESET_EMAIL_SENT);
  }
}

export async function clearSentPasswordEmailFlag(context) {
  console.log('clearSentPasswordEmailFlag');
  context.dispatch(Actions.USER_MANAGEMENT_PASSWORD_RESET_CONFIRMATION_DISPLAYED);
}

export async function showNewUserCreatedReminder(context) {
  console.log('showNewUserCreatedReminder');
  context.dispatch(Actions.USER_MANAGEMENT_SHOW_NEW_USER_CREATED_REMINDER);
}

export async function clearNewUserCreatedReminder(context) {
  console.log('clearNewUserCreatedReminder');
  context.dispatch(Actions.USER_MANAGEMENT_CLEAR_NEW_USER_CREATED_REMINDER);
}

export async function validationErrorsReceived(context, errors) {
  console.log('validationErrorsReceived', errors);
  context.dispatch(Actions.USER_MANAGEMENT_VALIDATION_ERROR_RECEIVED, errors);
}

export async function resetFormErrors(context) {
  console.log('resetFormErrors');
  context.dispatch(Actions.USER_MANAGEMENT_RESET_VALIDATION_ERRORS);
}

export async function setShowInactiveUsers(context, search) {
  console.log('setShowInactiveUsers');
  context.dispatch(Actions.USER_MANAGEMENT_SET_SHOW_INACTIVE_USERS, search);
}

export async function loadEmployees(context) {
  console.log('Loading Employees Data');
  context.dispatch(Actions.EMPLOYEES_LOAD_ALL);
  const { data } = await context.service.read('employees', {});
  context.dispatch( Actions.EMPLOYEES_LOADED, { data } );
  return data;
}



// WEBPACK FOOTER //
// ./src/apps/UserManagement/actions/UserManagementActionCreator.js